import { createApp } from 'vue'
import options from './BreadCrumb.options'

const el = '.kb-component--bread-crumb'
const DOM = document.querySelector(el)

export default function (Store) {
    if (!DOM || DOM.hasAttribute('data-v-app')) return

    const component = createApp(options).use(Store)
    component.mount(el)
}
